import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AcceptTermsOfUseMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AcceptTermsOfUseMutation = { __typename?: 'Mutation', acceptTermsOfUse: { __typename?: 'TermsOfUse', id: string, membersAccepted: Array<{ __typename?: 'OrganisationMemberUser', id: string }> } };


export const AcceptTermsOfUseDocument = gql`
    mutation AcceptTermsOfUse($id: ID!) {
  acceptTermsOfUse(id: $id) {
    id
    membersAccepted {
      id
    }
  }
}
    `;
export type AcceptTermsOfUseMutationFn = Apollo.MutationFunction<AcceptTermsOfUseMutation, AcceptTermsOfUseMutationVariables>;

/**
 * __useAcceptTermsOfUseMutation__
 *
 * To run a mutation, you first call `useAcceptTermsOfUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsOfUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsOfUseMutation, { data, loading, error }] = useAcceptTermsOfUseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptTermsOfUseMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsOfUseMutation, AcceptTermsOfUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsOfUseMutation, AcceptTermsOfUseMutationVariables>(AcceptTermsOfUseDocument, options);
      }
export type AcceptTermsOfUseMutationHookResult = ReturnType<typeof useAcceptTermsOfUseMutation>;
export type AcceptTermsOfUseMutationResult = Apollo.MutationResult<AcceptTermsOfUseMutation>;
export type AcceptTermsOfUseMutationOptions = Apollo.BaseMutationOptions<AcceptTermsOfUseMutation, AcceptTermsOfUseMutationVariables>;